// 👀: replace with mounted check (recommended from Staffs/PEs)
// logs true on server (initial)
// then logs false on client
export const isClient = typeof window !== 'undefined';
